import {GenerateCertificateState} from '../../schema';

export default class CertificateAvailability {
  /**
   * Returns true if the certificate generation is potentially available even if it is not available at the moment
   */
  static isPotentiallyAvailable(state: GenerateCertificateState): boolean {
    switch (state) {
      case GenerateCertificateState.FAIL_EVENT_NO_CERTIFICATE:
      case GenerateCertificateState.NOT_EXPECTED:
        return false;
      default:
        return true;
    }
  }

  /**
   * Returns true if the certificate generation is available at the moment
   */
  static isAvailable(state: GenerateCertificateState): boolean {
    return state === GenerateCertificateState.OK;
  }
}
